export const ConnectedIndicator = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="4"
        fill="var(--synapse-progress-success)"
        stroke="var(--synapse-progress-success)"
        strokeOpacity="0.125"
        strokeWidth="8"
      />
    </svg>
  )
}
